import { useMemo } from 'react'
import { userGetBookkeepingSubmission } from '@/features/bookkeeping/end-of-year-review/actions'
import {
  EndOfYearAdminReviewStep,
  Document,
} from '@/features/bookkeeping/end-of-year-review/types'
import { useFetchResponse } from '@/utils/sharedHooks'

export const useReviewItems = () => {
  const userBookkeepingSubmission = useFetchResponse(
    userGetBookkeepingSubmission
  )

  const {
    showPendingDocuments,
    showPendingBankStatements,
    showPendingTransaction,
    isPendingDocuments,
    isPendingBankStatements,
    isPendingTransaction,
  } = useMemo(() => {
    //Get Payroll Providers
    const steps = userBookkeepingSubmission?.steps || []

    const state = {
      showPendingBankStatements: false,
      showPendingTransaction: false,
      showPendingDocuments: false,
      isPendingBankStatements: false,
      isPendingTransaction: false,
      isPendingDocuments: false,
    }

    // TODO: This really should be properly typed rather than using
    // casting.
    steps.forEach((step) => {
      switch (step.step) {
        case EndOfYearAdminReviewStep.uploadMissingStatements:
          if (step.status === 'user_action_required') {
            state.showPendingBankStatements = true
          }
          if (!(step.context as { updatedByUser: boolean }).updatedByUser) {
            state.isPendingBankStatements = true
          }
          break
        case EndOfYearAdminReviewStep.transactions:
          if (step.status === 'user_action_required') {
            state.showPendingTransaction = true
          }
          if (!(step.context as { updatedByUser: boolean }).updatedByUser) {
            state.isPendingTransaction = true
          }
          break
        case EndOfYearAdminReviewStep.docsPayroll:
        case EndOfYearAdminReviewStep.docsContractorPayments:
        case EndOfYearAdminReviewStep.docsPreviousTaxReturn:
        case EndOfYearAdminReviewStep.docsProcessingFees:
          if (step.status === 'user_action_required') {
            state.showPendingDocuments = true
          }

          for (const doc of (step.context as { documents: Document[] })
            .documents) {
            if (doc.requestReUpload && !doc.updatedByUser) {
              state.isPendingDocuments = true
            }
          }
          break
        case EndOfYearAdminReviewStep.docsAssetsOver2500:
          if (step.status === 'user_action_required') {
            state.showPendingDocuments = true
          }

          for (const doc of (
            step.context as {
              receipts: { requestReUpload: boolean; updatedByUser: boolean }[]
            }
          ).receipts) {
            if (doc.requestReUpload && !doc.updatedByUser) {
              state.isPendingDocuments = true
            }
          }
          break
        case EndOfYearAdminReviewStep.unclarifiedTransactions:
        case EndOfYearAdminReviewStep.disconnectedAccounts:
        case EndOfYearAdminReviewStep.finalReview:
        case EndOfYearAdminReviewStep.docsOther:
          // No action needed
          break
        default:
          step.step satisfies never
      }
    })
    return state
  }, [userBookkeepingSubmission])

  return {
    showPendingBankStatements,
    showPendingTransaction,
    showPendingDocuments,
    isPendingBankStatements,
    isPendingTransaction,
    isPendingDocuments,
  }
}
